<div class="animated fadeInRight main-view-big" style="padding: 24px;">
  @if (this.isLoading) {
    <div>
      <mat-progress-bar mode="indeterminate" style="margin-top: 4px; margin-bottom: 4px;"></mat-progress-bar>
    </div>
  }

  @if (!isLoading && mainForm) {
    <form [formGroup]="mainForm" class="form-container" (ngSubmit)="onSubmit()">
      <!-- Allgemeine Einstellungen -->
      <div class="vertical-center" style="margin: 8px;">
        <mat-icon color="primary">settings</mat-icon>&nbsp;<b>{{'Einstellungen.AllgemeineEinstellungen' |
      translate}}</b>
    </div>
    <div class="outline-blue" style="margin-bottom: 19px;">
      <div class="row row-settings">
        <mat-checkbox color="primary" formControlName="auftragsbestätigung"
          matTooltip="{{'Einstellungen.InfoAuftragsbestätigung' | translate}}" [matTooltipPosition]="'before'" matTooltipClass="tooltip">
          {{'Einstellungen.Auftragsbestätigung' | translate}}
        </mat-checkbox>
      </div>
      <div class="row row-settings">
        <mat-checkbox color="primary" formControlName="vorrechlichesInkasso"
          matTooltip="{{'Einstellungen.InfoVorrechlichesInkasso' | translate}}" [matTooltipPosition]="'before'" matTooltipClass="tooltip">
          {{'Einstellungen.VorrechlichesInkasso' | translate}}
        </mat-checkbox>
      </div>
      <div class="row row-settings">
        <div class="col-md-6 no-padding">
          <mat-form-field appearance="fill" class="input-field" style="width:280px"
            matTooltip="{{'Einstellungen.InfoForderungsgrund' | translate}}" matTooltipClass="tooltip">
            <mat-label>{{'Einstellungen.Forderungsgrund' | translate}}</mat-label>
            <mat-select formControlName="standardGrund">
              @for (grund of this.oroservice.kundeninfo.Forderungsgruende; track grund) {
                <mat-option
                  [selected]="this.kundensettings.Forderungsgrund === grund.Id" [value]="grund.Id">
                  {{grund.Name}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row row-settings">
        <div class="col-md-6 no-padding">
          <mat-form-field appearance="fill" class="input-field" style="width:280px"
            matTooltip="{{'Einstellungen.InfoVerjährung' | translate}}" matTooltipClass="tooltip">
            <mat-label>{{'Einstellungen.Verjährung' | translate}}</mat-label>
            <mat-select formControlName="verjaehrung">
              <mat-option [value]="0">{{'Einstellungen.VerjährungVorrechtlich' | translate}}</mat-option>
              <mat-option [value]="1">{{'Einstellungen.VerjährungStandard' | translate}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <!-- <div class="row row-settings">
      {{'Einstellungen.SchnittstellenverarbeitungInfo' | translate}}
    </div>
    <div class="row row-settings">
      <div class="col-md-6 no-padding">
        <mat-form-field appearance="fill" class="input-field" style="width:280px">
          <mat-label>{{'Einstellungen.Schnittstellenverarbeitung' | translate}}</mat-label>
          <mat-select formControlName="schnittstellenverarbeitung">
            <mat-option [value]="0" disabled>{{'Einstellungen.SchnittstellenverarbeitungKeine' | translate}}</mat-option>
            <mat-option [value]="1" disabled>{{'Einstellungen.SchnittstellenverarbeitungXmlDebitoren' | translate}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div> -->
  </div>
  <!-- Einstellungen zum Dossierablauf -->
  <div class="vertical-center" style="margin: 20px 8px 8px;">
    <mat-icon color="primary">settings</mat-icon>&nbsp;<b>{{'Einstellungen.EinstellungenDossierablauf' |
  translate}}</b>
</div>
<div class="outline-blue" style="margin-bottom: 19px;">
  <div class="row row-settings">
    <mat-form-field appearance="fill" class="input-field" style="width:280px"
      matTooltip="{{'Einstellungen.InfoMahnstufen' | translate}}" matTooltipClass="tooltip">
      <mat-label>{{'Einstellungen.Mahnstufen' | translate}}</mat-label>
      <mat-select formControlName="mahnstufen" (selectionChange)="checkMahnstufen()">
        <mat-option [value]="1">1</mat-option>
        <mat-option [value]="2">2</mat-option>
        <mat-option [value]="3">3</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="row row-settings">
    {{'Einstellungen.InfoMahnfriste' | translate}}
  </div>
  <div class="row row-settings">
    @if (kundensettings.SendM1) {
      <mat-form-field appearance="fill" style="width:110px; padding: 0px;"
        matTooltip="{{'Einstellungen.InfoM1' | translate}}" matTooltipClass="tooltip">
        <input matInput formControlName="m1" style="margin: 0px;" placeholder="{{'RequiredPlaceholder' | translate}}" type="number" autocomplete='off'>
      </mat-form-field>
    }
    @if (kundensettings.SendM2) {
      <mat-form-field appearance="fill" style="width:110px; margin-left: 6px; padding: 0px;"
        matTooltip="{{'Einstellungen.InfoM2' | translate}}" matTooltipClass="tooltip">
        <input matInput formControlName="m2" style="margin: 0px;" placeholder="{{'RequiredPlaceholder' | translate}}" type="number" autocomplete='off'>
      </mat-form-field>
    }
    @if (kundensettings.SendM3) {
      <mat-form-field appearance="fill" style="width:110px; margin-left: 6px; padding: 0px;"
        matTooltip="{{'Einstellungen.InfoM3' | translate}}" matTooltipClass="tooltip">
        <input matInput formControlName="m3" style="margin: 0px;" placeholder="{{'RequiredPlaceholder' | translate}}" type="number" autocomplete='off'>
      </mat-form-field>
    }
  </div>
  @if (isErrorMahnung()) {
    <mat-error
      style="margin-bottom: 24px;">
      {{ getMahnungError() | translate}}
    </mat-error>
  }
  <mat-divider></mat-divider>
  <!-- Adressrecherche -->
  <div style="margin-left:16px">
    <b>{{'Einstellungen.AdressrechercheInfo' | translate}}</b>
  </div>
  <div class="row row-settings">
    <mat-form-field appearance="fill" class="input-field" style="width:280px;">
      <mat-select formControlName="adressrechercheIndex"
        (selectionChange)="onChangeAdressrecherche(true)">
        <mat-option [value]="0">{{'Einstellungen.AdressrechercheImmer' | translate}}</mat-option>
        <mat-option [value]="1">{{'Einstellungen.RückfrageImmer' | translate}}</mat-option>
        <mat-option [value]="2">{{'Einstellungen.DossierAbrechnen' | translate}}</mat-option>
        <mat-option [value]="3">{{'Einstellungen.IndividuelleEinstellung' | translate}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  @if (showAdressrecherche()) {
    <div class="row row-settings">
      {{'Einstellungen.AdressrechercheCustomInfo' | translate}}
    </div>
  }
  @if (showAdressrecherche()) {
    <div class="row row-settings">
      <mat-form-field appearance="fill" style="width:110px; padding: 0px;" floatLabel="always">
        <mat-label>{{'Einstellungen.Wert1' | translate}}</mat-label>
        <input matInput formControlName="adressrechercheWert1" style="text-align: center;" placeholder="{{'RequiredPlaceholder' | translate}}"
          type="number" matTooltip="{{'Einstellungen.Wert1Info' | translate}}" autocomplete='off'
          (change)="onChangeAdressrecherche(false)" matTooltipClass="tooltip">
        </mat-form-field>
        <mat-form-field appearance="fill" style="width:110px; margin-left: 6px; padding: 0px;" floatLabel="always">
          <mat-label>{{'Einstellungen.Wert2' | translate}}</mat-label>
          <input matInput formControlName="adressrechercheWert2" style="text-align: center;" placeholder="{{'RequiredPlaceholder' | translate}}"
            type="number" matTooltip="{{'Einstellungen.Wert2Adresse' | translate}}" autocomplete='off'
            (change)="onChangeAdressrecherche(false)" matTooltipClass="tooltip">
          </mat-form-field>
        </div>
      }
      @if (isErrorWert1Wert2('adressrechercheWert')) {
        <mat-error>
          {{ 'Einstellungen.ErrorWert1Wert2' | translate}}
        </mat-error>
      }
      @if (isErrorWertMax('adressrechercheWert2')) {
        <mat-error>
          {{ 'Einstellungen.ErrorWertMax' | translate}}
        </mat-error>
      }
      @if (isErrorWert1Wert2('adressrechercheWert') || isErrorWertMax('adressrechercheWert2')) {
        <BR/>
      }
      @if (!mainForm?.controls?.vorrechlichesInkasso?.value) {
        <div>
          <mat-divider></mat-divider>
          <!-- Betreibung -->
          <div style="margin-left:16px">
            <b>{{'Einstellungen.RechtlichInfo' | translate}}</b>
          </div>
          <div class="row row-settings">
            <mat-form-field appearance="fill" class="input-field" style="width:280px;">
              <mat-select formControlName="rechtlichIndex" (selectionChange)="onChangeRechtlich(true)">
                <mat-option [value]="0">{{'Einstellungen.RechtlichImmer' | translate}}</mat-option>
                <mat-option [value]="1">{{'Einstellungen.RückfrageImmer' | translate}}</mat-option>
                <mat-option [value]="2">{{'Einstellungen.DossierAbrechnen' | translate}}</mat-option>
                <mat-option [value]="3">{{'Einstellungen.IndividuelleEinstellung' | translate}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          @if (showRechtlich()) {
            <div class="row row-settings">
              {{'Einstellungen.RechtlichCustomInfo' | translate}}
            </div>
          }
          @if (showRechtlich()) {
            <div class="row row-settings">
              <mat-form-field appearance="fill" style="width:110px; padding: 0px;" floatLabel="always">
                <mat-label>{{'Einstellungen.Wert1' | translate}}</mat-label>
                <input matInput formControlName="rechtlichWert1" style="text-align: center;" placeholder="{{'RequiredPlaceholder' | translate}}"
                  type="number" matTooltip="{{'Einstellungen.Wert1Info' | translate}}" autocomplete='off'
                  (change)="onChangeRechtlich(false)" matTooltipClass="tooltip">
                </mat-form-field>
                <mat-form-field appearance="fill" style="width:110px; margin-left: 6px; padding: 0px;" floatLabel="always">
                  <mat-label>{{'Einstellungen.Wert2' | translate}}</mat-label>
                  <input matInput formControlName="rechtlichWert2" style="text-align: center;" placeholder="{{'RequiredPlaceholder' | translate}}"
                    type="number" matTooltip="{{'Einstellungen.Wert2Rechtlich' | translate}}" autocomplete='off'
                    (change)="onChangeRechtlich(false)" matTooltipClass="tooltip">
                  </mat-form-field>
                </div>
              }
              @if (isErrorWert1Wert2('rechtlichWert')) {
                <mat-error>
                  {{ 'Einstellungen.ErrorWert1Wert2' | translate}}
                </mat-error>
              }
              @if (isErrorWertMax('rechtlichWert2')) {
                <mat-error>
                  {{ 'Einstellungen.ErrorWertMax' | translate}}
                </mat-error>
              }
              @if (isErrorWert1Wert2('rechtlichWert') || isErrorWertMax('rechtlichWert2')) {
                <BR/>
              }
              <!-- Bonitätsprüfung -->
              <div style="margin-left:16px">
                <b>{{'Einstellungen.BonitätsprüfungInfo' | translate}}</b>
              </div>
              <div class="row row-settings">
                <mat-form-field appearance="fill" class="input-field" style="width:280px;">
                  <mat-select formControlName="bonitaetspruefungIndex"
                    (selectionChange)="onChangeBonitaetspruefung()">
                    <mat-option [value]="0">{{'Einstellungen.BonitätsprüfungImmer' | translate}}</mat-option>
                    <mat-option [value]="1">{{'Einstellungen.BonitätsprüfungNie' | translate}}</mat-option>
                    <mat-option [value]="3">{{'Einstellungen.IndividuelleEinstellung' | translate}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              @if (mainForm?.controls?.bonitaetspruefungIndex?.value == 3) {
                <div class="row row-settings">
                  {{'Einstellungen.BonitätsprüfungCustomInfo' | translate}}
                </div>
              }
              @if (mainForm?.controls?.bonitaetspruefungIndex?.value == 3) {
                <div class="row row-settings">
                  <mat-form-field appearance="fill" style="width:110px; margin-left: 6px; padding: 0px;" floatLabel="always">
                    <mat-label>{{'Einstellungen.Wert' | translate}}</mat-label>
                    <input matInput formControlName="bonitaetspruefungWert" style="text-align: center;"
                      autocomplete='off' placeholder="{{'RequiredPlaceholder' | translate}}" type="number"
                      matTooltip="{{'Einstellungen.WertBonitätsprüfung' | translate}}" matTooltipClass="tooltip">
                    </mat-form-field>
                  </div>
                }
                @if (isErrorWertMax('bonitaetspruefungWert')) {
                  <mat-error>
                    {{ 'Einstellungen.ErrorWertMax' | translate}}
                  </mat-error>
                }
                @if (isErrorWertMax('bonitaetspruefungWert')) {
                  <BR/>
                }
                @if (mainForm?.controls?.bonitaetspruefungIndex?.value != 1) {
                  <div>
                    <mat-divider></mat-divider>
                    <!-- Bonitätsprüfung Rückfrage -->
                    <div style="margin-left:16px">
                      <b>{{'Einstellungen.BonitätsprüfungRückInfo' | translate}}</b>
                    </div>
                    <div class="row row-settings">
                      <mat-form-field appearance="fill" class="input-field" style="width:280px">
                        <mat-select formControlName="betreibRueckfrage">
                          <mat-option [value]="0">{{'Einstellungen.BetreibungsprüfungRückfrage.Keine' |
                            translate}}
                          </mat-option>
                          <mat-option [value]="1">{{'Einstellungen.BetreibungsprüfungRückfrage.Alle' | translate}}
                          </mat-option>
                          <mat-option [value]="2">{{'Einstellungen.BetreibungsprüfungRückfrage.Schlecht' |
                            translate}}
                          </mat-option>
                          <mat-option [value]="3">{{'Einstellungen.BetreibungsprüfungRückfrage.Gut' | translate}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
          <!-- Einstellungen zum Portfolio -->
          <div class="vertical-center" style="margin: 20px 8px 8px;">
            <mat-icon color="primary">settings</mat-icon>&nbsp;<b>{{'Einstellungen.EinstellungenPortfolio' |
          translate}}</b>
        </div>
        <div class="outline-blue" style="margin-bottom: 19px;">
          @if (!mainForm?.controls?.vorrechlichesInkasso?.value) {
            <div class="row row-settings">
              <mat-checkbox color="primary" formControlName="verlustscheinverwaltung"
                (change)="openDialogVSVerwaltungAktivierenOderDeaktivieren()"
                matTooltip="{{'Einstellungen.InfoVerlustscheinverwaltung' | translate}}" [matTooltipPosition]="'before'" matTooltipClass="tooltip">
                {{'Einstellungen.Verlustscheinverwaltung' | translate}}
              </mat-checkbox>
            </div>
          }
          @if (!kundensettings?.NurVorrechtInkasso) {
            <mat-divider></mat-divider>
          }
          <!-- Erbrecherche -->
          <div style="margin-left:16px">
            <b>{{'Einstellungen.ErbrechercheInfo' | translate}}</b>
          </div>
          <div class="row row-settings">
            <mat-form-field appearance="fill" class="input-field" style="width:280px;">
              <mat-select formControlName="erbrechercheIndex" (selectionChange)="onChangeErbrecherche(true)">
                <mat-option [value]="0">{{'Einstellungen.ErbrechercheImmer' | translate}}</mat-option>
                <mat-option [value]="1">{{'Einstellungen.RückfrageImmer' | translate}}</mat-option>
                <mat-option [value]="2">{{'Einstellungen.DossierAbrechnen' | translate}}</mat-option>
                <mat-option [value]="3">{{'Einstellungen.IndividuelleEinstellung' | translate}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          @if (showErbrecherche()) {
            <div class="row row-settings">
              {{'Einstellungen.ErbrechercheCustomInfo' | translate}}
            </div>
          }
          @if (showErbrecherche()) {
            <div class="row row-settings">
              <mat-form-field appearance="fill" style="width:110px; padding: 0px;" floatLabel="always">
                <mat-label>{{'Einstellungen.Wert1' | translate}}</mat-label>
                <input matInput formControlName="erbrechercheWert1" style="text-align: center;" placeholder="{{'RequiredPlaceholder' | translate}}"
                  type="number" matTooltip="{{'Einstellungen.Wert1Info' | translate}}" autocomplete='off'
                  (change)="onChangeErbrecherche(false)" matTooltipClass="tooltip">
                </mat-form-field>
                <mat-form-field appearance="fill" style="width:110px; margin-left: 6px; padding: 0px;" floatLabel="always">
                  <mat-label>{{'Einstellungen.Wert2' | translate}}</mat-label>
                  <input matInput formControlName="erbrechercheWert2" style="text-align: center;" placeholder="{{'RequiredPlaceholder' | translate}}"
                    type="number" matTooltip="{{'Einstellungen.Wert2Erbrecherche' | translate}}" autocomplete='off'
                    (change)="onChangeErbrecherche(false)" matTooltipClass="tooltip">
                  </mat-form-field>
                </div>
              }
              @if (isErrorWert1Wert2('erbrechercheWert')) {
                <mat-error>
                  {{ 'Einstellungen.ErrorWert1Wert2' | translate}}
                </mat-error>
              }
              @if (isErrorWertMax('erbrechercheWert2')) {
                <mat-error>
                  {{ 'Einstellungen.ErrorWertMax' | translate}}
                </mat-error>
              }
              @if (isErrorWert1Wert2('erbrechercheWert') || isErrorWertMax('erbrechercheWert2')) {
                <BR/>
              }
              <mat-divider></mat-divider>
              <!-- Auslandinkasso -->
              <div style="margin-left:16px">
                <b>{{'Einstellungen.AuslandInfo' | translate}}</b>
              </div>
              <div class="row row-settings">
                <mat-form-field appearance="fill" class="input-field" style="width:280px;">
                  <mat-select formControlName="auslandIndex" (selectionChange)="onChangeAusland(true)">
                    <mat-option [value]="0">{{'Einstellungen.AuslandImmer' | translate}}</mat-option>
                    <mat-option [value]="1">{{'Einstellungen.RückfrageImmer' | translate}}</mat-option>
                    <mat-option [value]="2">{{'Einstellungen.DossierAbrechnen' | translate}}</mat-option>
                    <mat-option [value]="3">{{'Einstellungen.IndividuelleEinstellung' | translate}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              @if (showAusland()) {
                <div class="row row-settings">
                  {{'Einstellungen.AuslandCustomInfo' | translate}}
                </div>
              }
              @if (showAusland()) {
                <div class="row row-settings">
                  <mat-form-field appearance="fill" style="width:110px; padding: 0px;" floatLabel="always">
                    <mat-label>{{'Einstellungen.Wert1' | translate}}</mat-label>
                    <input matInput formControlName="auslandWert1" style="text-align: center; padding: 0px;" placeholder="{{'RequiredPlaceholder' | translate}}"
                      type="number" matTooltip="{{'Einstellungen.Wert1Info' | translate}}" autocomplete='off'
                      (change)="onChangeAusland(false)" matTooltipClass="tooltip">
                    </mat-form-field>
                    <mat-form-field appearance="fill" style="width:110px; margin-left: 6px; padding: 0px;" floatLabel="always">
                      <mat-label>{{'Einstellungen.Wert2' | translate}}</mat-label>
                      <input matInput formControlName="auslandWert2" style="text-align: center;" placeholder="{{'RequiredPlaceholder' | translate}}"
                        type="number" matTooltip="{{'Einstellungen.Wert2Ausland' | translate}}" autocomplete='off'
                        (change)="onChangeAusland(false)" matTooltipClass="tooltip">
                      </mat-form-field>
                    </div>
                  }
                  @if (isErrorWert1Wert2('auslandWert')) {
                    <mat-error>
                      {{ 'Einstellungen.ErrorWert1Wert2' | translate}}
                    </mat-error>
                  }
                  @if (isErrorWertMax('auslandWert2')) {
                    <mat-error>
                      {{ 'Einstellungen.ErrorWertMax' | translate}}
                    </mat-error>
                  }
                  @if (isErrorWert1Wert2('auslandWert') || isErrorWertMax('auslandWert2')) {
                    <BR/>
                  }
                </div>
                <div class="row row-settings" style="background-color: transparent;">
                  <button mat-flat-button color="primary" class="button-standard" type="submit" style="width:200px"
                    [disabled]="!mainForm.valid">
                    <mat-icon>save</mat-icon>&nbsp; {{'Speichern' | translate}}
                  </button>
                </div>
              </form>
            }
          </div>